import React from 'react';
import { Row } from 'react-table';

import { Quality, QualityValue } from '../../../../Types/LotDetailQuality';
import GetQualityColumnClass from './GetQualityColumnClass';

export interface QualityCellProps {
    row: Row<Quality>,
    qualityType: string,
    showConfidence: boolean
}

function QualityCell({ row, qualityType, showConfidence }: QualityCellProps): React.JSX.Element {
    let value = null;
    let confidence = "";
    let className = "";

    row.original.qualityValues.forEach(function (qualityValue:QualityValue) {

        if (qualityValue.testMethod === qualityType) {
            value = qualityValue.resultValue;
            className = GetQualityColumnClass(qualityValue);

            if (showConfidence && value !== "" && qualityValue.status.includes("Lo")) {
                confidence = " (Lo)";
            }
        }
    });

    return <div className={'quality-value-column ' + className}>
        {value}{confidence}
    </div>;
}

export default QualityCell;